"use strict";

var _span, _Text;
import "core-js/modules/es.symbol.description.js";
import { CDN } from '@autoguru/global-configs';
import { Box, Column, Columns, Heading, Stack, Text, useTextStyles } from '@autoguru/overdrive';
import { NextPicture, Picture } from '@autoguru/picture';
import * as styles from '~/src/components/KiaOraIntro/KiaOraIntro.css';
import { contentIntro } from '~/src/components/KiaOraIntro/contentIntro';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export * from './contentIntro';
export const ScrollToForm = () => {
  const scrollDiv = document.getElementById('learn-more').offsetTop;
  window.scrollTo({
    top: scrollDiv,
    behavior: 'smooth'
  });
  return null;
};
export const KiaOraIntroMobile = () => /*#__PURE__*/_jsx(Box, {
  position: "relative",
  children: /*#__PURE__*/_jsxs(Columns, {
    children: [/*#__PURE__*/_jsx(Column, {
      width: "full",
      alignSelf: "centre",
      paddingX: "6",
      className: styles.contentLeft,
      children: /*#__PURE__*/_jsxs(Stack, {
        space: "4",
        children: [/*#__PURE__*/_jsxs(Stack, {
          space: "4",
          children: [/*#__PURE__*/_jsxs(Heading, {
            as: "h1",
            size: "8",
            align: "center",
            children: [contentIntro.title, _span || (_span = /*#__PURE__*/_jsx("span", {
              children: " "
            })), _Text || (_Text = /*#__PURE__*/_jsx(Text, {
              strong: true,
              size: "8",
              colour: "success",
              children: "faster"
            }))]
          }), /*#__PURE__*/_jsx(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/_jsx(Picture, {
              lazy: true,
              backgroundColor: "transparent",
              altText: "arc",
              sizes: "180px",
              width: 40,
              height: "auto",
              aspectRatio: 50 / 15,
              src: `${CDN}/images/nz/landing/otto-smile.svg`
            })
          })]
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          size: "4",
          align: "center",
          children: contentIntro.description
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          size: "4",
          align: "center",
          children: contentIntro.subText
        })]
      })
    }), /*#__PURE__*/_jsx(Column, {
      width: "full",
      marginTop: "4",
      marginBottom: "7",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "1",
      overflow: "hidden",
      paddingX: "5",
      className: styles.contentRight,
      children: /*#__PURE__*/_jsx(NextPicture, {
        objectFit: "contain",
        sizes: "100vw",
        quality: 80,
        backgroundColor: "transparent",
        altText: contentIntro.altImgFeaturedText,
        aspectRatio: contentIntro.mobileAspectRatioImgFeatured,
        src: `${CDN}/images/nz/landing/${contentIntro.mobileImgFeaturedPath}`
      })
    }), /*#__PURE__*/_jsx(Column, {
      width: "full",
      marginTop: "4",
      marginBottom: "7",
      paddingX: "4",
      className: styles.contentRight,
      children: /*#__PURE__*/_jsxs(Columns, {
        space: "3",
        children: [/*#__PURE__*/_jsx(Column, {
          grow: true,
          width: "auto",
          alignSelf: "centre",
          display: "block",
          as: "a",
          href: "/login",
          rel: "noopener noreferrer nofollow",
          flexGrow: 1,
          marginRight: "6",
          paddingX: "4",
          paddingY: "3",
          backgroundColour: "white",
          borderColour: "dark",
          borderWidth: "1",
          borderRadius: "1",
          textAlign: "center",
          className: useTextStyles({
            colour: 'dark',
            weight: 'bold'
          }),
          children: contentIntro.btnLogin
        }), /*#__PURE__*/_jsx(Column, {
          grow: true,
          width: "auto",
          alignSelf: "centre",
          display: "block",
          as: "button",
          flexGrow: 1,
          paddingX: "4",
          paddingY: "3",
          backgroundColour: "green500",
          borderRadius: "1",
          borderWidth: "1",
          textAlign: "center",
          className: styles.btnLearnMore,
          onClick: ScrollToForm,
          children: /*#__PURE__*/_jsx(Box, {
            className: useTextStyles({
              colour: 'dark',
              weight: 'bold'
            }),
            children: contentIntro.btnLearnMore
          })
        })]
      })
    })]
  })
});